VideoModeStore = LP.module('VideoModeStore')
LpBoclips  = LP.module('LpBoclips')
require('../components/boclips_modal')

BoclipsModal = LP.module('LpBoclips').BoclipsModal
class VideoModeStore extends FluxBaseStore
  @storeName: 'VideoModeStore'
  @VIEW_INITIAL = 'VIEW_INITIAL'
  @VIEW_MORE = 'VIEW_MORE'
  @VIEW_ALL = 'VIEW_ALL'

  @STORAGE_PER_PAGE_KEY = "lp-videos-per-page"
  @STORAGE_VIDEO_PAGES = 'lp-videos-total-pages'
  @STORAGE_ONLY_VIDEOS = 'lp-videos-ext-only'

  @BOCLIPS_VIDEO_TYPES_MAPPING = {
    'Instructional': '1',
    'News Clips': '2',
    'Stock Footage': '3'
  }

  @handlers:
    RECEIVE_FACETS: 'receiveFacets'
    RECEIVE_SEARCH: 'updatePage'
    SHOW_RESOURCE: 'show'
    HIDE_RESOURCE: 'hide'
    TOGGLE_FACET: 'toggleFacet'
    CLEAR_ALL:  'clearAll'

    SET_PARAM:     'saveVideosPerPage'
    SET_PARAMS:    'saveVideosPerPage'

    VIDEOS_TOGGLE_RESET_VIEW: 'resetView'
    VIDEOS_TOGGLE_VIEW_ALL: 'toggleViewAll'
    VIDEOS_TOGGLE_VIEW_MORE: 'toggleViewMore'
    VIDEOS_RECEIVE_SEARCH: 'receiveVideosSearch'
    VIDEOS_BACK_FORWARD_NAVIGATION: 'goBackOrForward'

  initialize: ({config} = { config: LP.config }) ->
    @_params = { search_params:  config.search_params || {} }
    @_page = config.search_page
    @_totalPages = @.getFromStorage(VideoModeStore.STORAGE_VIDEO_PAGES)
    @_searchResultsCount = config.search_results_count
    @_videoResourceTypeId = config.video_resource_type_id
    @_receivedFacets = 0
    @_videoLengthPanelVisible = false
    @_rawVideosCount = null
    @_resetView = null
    @_apiUnavailable = null
    @_viewAllForced = null
    @_loading = !@.isInValid() && @.pageInBounds()
    @_triggerSearch = !@.isInValid() && @.pageInBounds()
    @_fromBackOrForwardButton = false
    @_historyNavigationTriggerSearch = false
    @_invalidUsagePermissions = @invalidUsagePermissions()
    @_currentQuery = document.location.href
    if window.history.state?
      @.goBackOrForward(window.history.state)

  currentState: ->
    {
      loading: @_loading,
      triggerSearch: @_triggerSearch,
      searchResultsCount: @_searchResultsCount,
      page: @_page,
      valid: !@.isInValid() && @.pageInBounds(),

      viewInitial: @.canViewInitial()
      viewMore: @.canViewMore(),
      viewAll:  @.canViewAll(),
      viewFull: (@.validCanViewAll() && @_searchResultsCount == 0) || @.onlyExternalVideos(),
      onlyVideo: @._getVideoFacet()? && @.onlyVideoResourceType(),

      results: @_results,
      rawVideosCount : @_rawVideosCount
      resetView: @_resetView,
      totalPages: parseInt(@_totalPages) || null,
      apiUnavailable: @_apiUnavailable,
      historyNavigationTriggerSearch: @_historyNavigationTriggerSearch
      fromBackOrForwardButton: @_fromBackOrForwardButton
      onlyExternalVideos:  @.onlyExternalVideos()
      emptyExternalVideosOnly: @.emptyExternalVideosOnly()
    }

  emptyExternalVideosOnly: ->
    return false if @_resetView || !@.onlyExternalVideos()
    return false if !@.isInValid() && @.pageInBounds()
    @_rawVideosCount == 0 && @_searchResultsCount == 0

  receiveFacets: ({rawFacets}) ->
    self = this
    @.setReceivedFacets()
    if @hasReceivedFacetsFirstTime()
      @dispatcher.waitFor ['FacetStore'], ->
        self.setFacetsForInvalidFiltering()
        self.toggleVideoTypeFacetsIfNeeded(emit: false, toggleOnlyVideos: true)
        self.resetViewIfNeeded(emit: false,  toggleOnlyVideos: true)
        self._setHistoryVideosPerPage()
        self.emitChange()
    else
      @dispatcher.waitFor ['FacetStore'], ->
        self.setFacetsForInvalidFiltering()
        self.toggleVideoTypeFacetsIfNeeded(emit: true,  toggleOnlyVideos: true)

  updatePage: ({rawSearch, paramsDidChange}) ->
    self = this
    @dispatcher.waitFor ['ParamStore', 'FacetStore', 'SearchStore'], ->
      self._params = {
        search_params: rawSearch.search_params,
        paramsDidChange: paramsDidChange
      }
      self._page = rawSearch.page
      self._searchResultsCount = rawSearch.raw_results_count
      self._triggerSearch = !self.isInValid() && self.pageInBounds()
      self._loading = !self.isInValid() && self.pageInBounds()
      per_page = self.getFromStorage(LpBoclips.VideoModeStore.STORAGE_PER_PAGE_KEY)
      self.resetViewIfNeeded(emit: false,  toggleOnlyVideos: true)
      if per_page == LpBoclips.VideoModeStore.VIEW_ALL && !self.canViewAll()
        self._setHistoryVideosPerPage(val: LpBoclips.VideoModeStore.VIEW_INITIAL)
      else
        self._setHistoryVideosPerPage()
      self.emitChange()

  show: ({url, transition, videoUrl, type, noHistory, fromBackButton}) ->
    self = this
    self._fromBackOrForwardButton = fromBackButton == true || noHistory == true
    @dispatcher.waitFor ['ResourceStore', 'RouteStore'], ->
      self._setHistoryVideosPerPage()
      return if !url? || String(type) != 'boclips_video'
      new BoclipsModal(
        url,
        videoUrl,
        {},
        transition
      ).show()

  hide: ({query, noHistory, fromBackButton} = {query: null, noHistory: null, fromBackButton: null}) ->
    self = this
    self._fromBackOrForwardButton = fromBackButton == true || noHistory == true
    @dispatcher.waitFor ['RouteStore'], ->
      BoclipsModal.hide()
      if query?
        per_page = self.getFromStorage(LpBoclips.VideoModeStore.STORAGE_PER_PAGE_KEY)
        self.resetViewIfNeeded(emit: !self._loading, toggleOnlyVideos: false)
        if per_page == LpBoclips.VideoModeStore.VIEW_ALL && !self.canViewAll()
          self._setHistoryVideosPerPage(val: LpBoclips.VideoModeStore.VIEW_INITIAL)
        else
          self._setHistoryVideosPerPage()
        return if self._loading
        self._loading = true
        self.emitChange()

  toggleFacet: ({facet, noHistory, fromBackButton}) ->
    self = this
    self._fromBackOrForwardButton = fromBackButton == true || noHistory == true
    @dispatcher.waitFor ['FacetStore', 'ParamStore', 'RouteStore'], ->
      per_page = self.getFromStorage(LpBoclips.VideoModeStore.STORAGE_PER_PAGE_KEY)
      self.resetViewIfNeeded(emit: !self._loading,  toggleOnlyVideos: true)
      self.resetFromStorage(LpBoclips.VideoModeStore.STORAGE_VIDEO_PAGES)
      if per_page == LpBoclips.VideoModeStore.VIEW_ALL && !self.canViewAll()
        self._setHistoryVideosPerPage(val: LpBoclips.VideoModeStore.VIEW_INITIAL)
      else
        self._setHistoryVideosPerPage()
      self._totalPages = null
      return if self._loading
      self._loading = true
      self.emitChange()

  clearAll: ({noHistory, fromBackButton}) ->
    self = this
    self._fromBackOrForwardButton = fromBackButton == true || noHistory == true
    @dispatcher.waitFor ['FacetStore', 'ParamStore', 'RouteStore'], ->
      per_page = self.getFromStorage(LpBoclips.VideoModeStore.STORAGE_PER_PAGE_KEY)
      self.resetView(emit: false)
      self._triggerSearch = false
      if per_page == LpBoclips.VideoModeStore.VIEW_ALL && !self.canViewAll()
        self._setHistoryVideosPerPage(val: LpBoclips.VideoModeStore.VIEW_INITIAL)
      else
        self._setHistoryVideosPerPage()
      self.emitChange()

  receiveVideosSearch: ({rawSearch} = {rawSearch: {}}) ->
    if rawSearch.results?
      @_results = rawSearch.results
    if rawSearch.search_count?
      @_searchResultsCount = rawSearch.search_count
    if rawSearch.raw_videos_count?
      @_rawVideosCount = rawSearch.raw_videos_count
    if rawSearch.api_unavailable?
      @_apiUnavailable = rawSearch.api_unavailable
    if rawSearch.total_pages?
      @_totalPages = rawSearch.total_pages
      @.saveInStorage(VideoModeStore.STORAGE_VIDEO_PAGES, @_totalPages)
    @_viewAllForced = null
    @_loading = false
    @_triggerSearch = false
    @.setReceivedFacets()
    @.toggleVideoTypeFacetsIfNeeded(emit: false,  toggleOnlyVideos: true)
    @.emitChange()

  pageInBounds: ->
    return true if !@_totalPages? || !@_page?
    pageNumber = parseInt(@_page) || 0
    totalNumber = parseInt(@_totalPages) || 0
    return true if pageNumber <= 1 || totalNumber <= 1
    pageNumber <= totalNumber

  invalidUsagePermissions: ->
    facets = @._getUsagePermissionsFacets()
    return [] if !Array.isArray(facets)
    rejected = ['Fine Print', 'Fine Print: Educational Use']
    facets.filter((facet) -> rejected.indexOf(facet.title) == -1 ).map((facet) -> facet.id )

  isInValid: ->
    self = this
    searchParams = self.getAll().search_params
    searchParams = {} unless searchParams?
    if Array.isArray(searchParams.provider_ids) && searchParams.provider_ids.length > 0
      return true
    if Array.isArray(searchParams.ss_ids) && searchParams.ss_ids.length > 0
      return true
    if Array.isArray(searchParams.ccss) && searchParams.ccss.length > 0
      return true
    if Array.isArray(searchParams.ngss) && searchParams.ngss.length > 0
      return true
    if Array.isArray(self._invalidUsagePermissions) && Array.isArray(searchParams.usage_permission_ids) && searchParams.usage_permission_ids.filter( (usage_id) ->
      self._invalidUsagePermissions.indexOf(usage_id) != -1
    ).length > 0
      return true
    if searchParams.lexile_measures?
      return true
    validResourceType = @.validResourceTypes(searchParams)
    if !validResourceType
      return true
    @_rawVideosCount == 0 && !@_apiUnavailable && !@_loading && !@_triggerSearch

  hasReceivedFacets: ->
    @_receivedFacets >= 1

  hasReceivedFacetsFirstTime: ->
    @_receivedFacets == 1

  setReceivedFacets: ->
    return if @_receivedFacets > 1
    @_receivedFacets += 1

  setFacetsForInvalidFiltering: ->
    if !@_invalidUsagePermissions || (Array.isArray(@_invalidUsagePermissions) && @_invalidUsagePermissions.length == 0)
      @_invalidUsagePermissions = @.invalidUsagePermissions()

  resetViewIfNeeded: ({emit, toggleOnlyVideos} = {emit: true, toggleOnlyVideos: true} ) ->
    @.toggleVideoTypeFacetsIfNeeded(emit: emit,  toggleOnlyVideos: toggleOnlyVideos)
    return if @_viewAllForced == true
    if @.canViewAll() && !@.onlyVideoResourceType()
      @resetFromStorage(LpBoclips.VideoModeStore.STORAGE_PER_PAGE_KEY)
      @resetFromStorage(LpBoclips.VideoModeStore.STORAGE_VIDEO_PAGES)
      @resetFromStorage(LpBoclips.VideoModeStore.STORAGE_ONLY_VIDEOS)
      @_totalPages = null
      @_resetView = true

  resetView: ({emit} = {emit: true} ) ->
    @resetFromStorage(LpBoclips.VideoModeStore.STORAGE_PER_PAGE_KEY)
    @resetFromStorage(LpBoclips.VideoModeStore.STORAGE_VIDEO_PAGES)
    @resetFromStorage(LpBoclips.VideoModeStore.STORAGE_ONLY_VIDEOS)
    @_totalPages = null
    @_resetView = false
    @_loading = true
    @_triggerSearch = true
    @.toggleVideoTypeFacetsIfNeeded(emit: !emit && !@_fromBackOrForwardButton, toggleOnlyVideos: false)
    @.emitChange() if emit

  toggleViewMore: ({emit ,addHistory} = {emit: true, addHistory: true} ) ->
    per_page = LpBoclips.VideoModeStore.STORAGE_PER_PAGE_KEY
    if @.canViewMore()
      @.resetFromStorage(per_page)
    else
      @.saveInStorage(per_page, LpBoclips.VideoModeStore.VIEW_MORE)
    @._setHistoryVideosPerPage(val: LpBoclips.VideoModeStore.VIEW_INITIAL, ignore: !addHistory)
    @.emitChange() if emit

  toggleViewAll: ({emit} = {emit: true} ) ->
    per_page = LpBoclips.VideoModeStore.STORAGE_PER_PAGE_KEY
    @resetFromStorage(LpBoclips.VideoModeStore.STORAGE_VIDEO_PAGES)
    if @.canViewAll()
      @resetFromStorage(per_page)
    else
      @saveInStorage(per_page, LpBoclips.VideoModeStore.VIEW_ALL)
    @_loading = true
    @_triggerSearch = false
    @_totalPages = null
    @.toggleVideoTypeFacetsIfNeeded(emit: false,  toggleOnlyVideos: true)
    @.emitChange() if emit

  getAll: ->
    searchParams = @dispatcher.getStore('ParamStore').getAll()
    @_params.paramsDidChange = (key for own key of searchParams).length > 0
    @_params.per_page = @.getFromStorage(VideoModeStore.STORAGE_PER_PAGE_KEY)
    $.extend(true, {}, { search_params: searchParams }, @_params)

  filteredByKeywords: ->
    searchParams = @.getAll().search_params || {}
    keywords = searchParams.keywords
    keywords? && $.trim(String(keywords)) != ''

  toggleVideoTypeFacetsIfNeeded: ({emit, toggleOnlyVideos, params} = { emit: true, toggleOnlyVideos: true, params: {}} ) ->
    self = this
    videoTypes = @.getActiveVideoTypes(params)
    if Array.isArray(videoTypes) && videoTypes.length > 0
      oldFlag = videoTypes[0].hidden
      hiddenFlag = @_viewAllForced != true && !self.canViewAll()
      videoTypes.filter( (facet) ->
        facet.hidden = hiddenFlag
      )
      emitFlag = emit && oldFlag != hiddenFlag
      self.toggleBoclipsOnlyFlagIfNeeded(emit: !emitFlag) if toggleOnlyVideos
      self.emitChange() if emitFlag

  toggleBoclipsOnlyFlagIfNeeded:  ({emit, params} = { emit: true, params: {}})->
    videoTypes = @.getActiveVideoTypes(params)
    if !Array.isArray(videoTypes) || videoTypes.length < 1
      @.resetFromStorage(LpBoclips.VideoModeStore.STORAGE_ONLY_VIDEOS)
      return
    instructional_type_id =  LpBoclips.VideoModeStore.BOCLIPS_VIDEO_TYPES_MAPPING['Instructional']
    required_type_ids = ['News Clips', 'Stock Footage'].map((name) -> LpBoclips.VideoModeStore.BOCLIPS_VIDEO_TYPES_MAPPING[name])

    instructional_facets = videoTypes.filter( (facet) ->
      [instructional_type_id].indexOf(facet.id) != -1
    )
    facets = videoTypes.filter( (facet) ->
      required_type_ids.indexOf(facet.id) != -1
    )
    activated = false
    old_activation = @.getFromStorage(LpBoclips.VideoModeStore.STORAGE_ONLY_VIDEOS)
    if old_activation == null || typeof(old_activation) == 'undefined'
      old_activation = false
    if @.validCanViewAll() && facets.length > 0 && instructional_facets.length == 0
      @.saveInStorage(LpBoclips.VideoModeStore.STORAGE_ONLY_VIDEOS, 'true')
      activated = true
    else
      @.resetFromStorage(LpBoclips.VideoModeStore.STORAGE_ONLY_VIDEOS)
      activated = false
    @.emitChange() if emit && String(activated) != String(old_activation)

  getActiveVideoTypes: (params) ->
    facetStore = @dispatcher.getStore('FacetStore')
    videoTypes = facetStore.get('video_types', { sorted: true })
    return [] unless Array.isArray(videoTypes)
    searchParams = if params? then params else this.getAll().search_params
    searchParams = {} unless searchParams?
    type_ids = searchParams.video_types
    return [] unless Array.isArray(type_ids)
    videoTypes.filter( (facet) ->
      type_ids.indexOf(facet.id) != -1
    )

  _getVideoFacet: ->
    facetStore = @dispatcher.getStore('FacetStore')
    resource_types = facetStore.get('type_ids', { sorted: true })
    resource_types.filter( (facet) ->
      return facet.title == 'Instructional Videos'
    )[0]

  _getUsagePermissionsFacets: ->
    facetStore = @dispatcher.getStore('FacetStore')
    facetStore.get('usage_permission_ids', { sorted: true })

  onlyVideoResourceType: (params) ->
    videoFacet = @._getVideoFacet()
    videoFacetId = @_videoResourceTypeId
    if videoFacet?
      videoFacetId = videoFacet.id
    searchParams = if params? then params else this.getAll().search_params
    searchParams = {} unless searchParams?
    type_ids = searchParams.type_ids
    (Array.isArray(type_ids) && type_ids.length == 1 &&
      type_ids[0] == videoFacetId)

  validResourceTypes: (params) ->
    videoFacet = @._getVideoFacet()
    return true unless videoFacet?
    resource_types = [videoFacet.id]
    searchParams = if params? then params else this.getAll().search_params
    searchParams = {} unless searchParams?
    type_ids = searchParams.type_ids
    if !type_ids || (Array.isArray(type_ids) && type_ids.length == 0)
      return true
    if !Array.isArray(resource_types) || !Array.isArray(type_ids)
      return false
    type_ids.filter( (type_id) ->
      resource_types.indexOf(type_id) != -1
    ).length > 0

  validCanViewAll: () ->
    this.canViewAll() && this.onlyVideoResourceType()

  canViewMore: ->
    per_page = String(@.getFromStorage(VideoModeStore.STORAGE_PER_PAGE_KEY))
    per_page ==  String(VideoModeStore.VIEW_MORE)

  canViewAll: ->
    per_page = String(@.getFromStorage(VideoModeStore.STORAGE_PER_PAGE_KEY))
    per_page == String(VideoModeStore.VIEW_ALL)

  canViewInitial: ->
    !@.getFromStorage(VideoModeStore.STORAGE_PER_PAGE_KEY)

  visitCurrentPath: ->
    String(@_currentQuery) == String(document.location.href)

  onlyExternalVideos: ->
    return false if !@.validCanViewAll()
    per_page = String(@.getFromStorage(VideoModeStore.STORAGE_ONLY_VIDEOS))
    per_page == 'true'

  saveInStorage: (key, val) ->
    return false unless @_validStorageKey(key)
    $.cookie(key, val, path: "/;SameSite=None", secure: true, httponly: false)

  getFromStorage: (key) ->
    return null unless @_validStorageKey(key)
    $.cookie(key)

  resetFromStorage: (key)->
    return unless @_validStorageKey(key)
    $.removeCookie(key, { 'max-age': -1, path: "/;SameSite=None", secure: true })

  _validStorageKey: (key) ->
    (key in [VideoModeStore.STORAGE_PER_PAGE_KEY,
      VideoModeStore.STORAGE_VIDEO_PAGES,
      VideoModeStore.STORAGE_ONLY_VIDEOS])

  saveVideosPerPage: ({noHistory, fromBackButton}) ->
    self = this
    self._fromBackOrForwardButton = fromBackButton == true || noHistory == true
    @dispatcher.waitFor ['RouteStore'], ->
      self._setHistoryVideosPerPage()

  _validPerPageKey: (per_page) ->
    (per_page in [VideoModeStore.VIEW_INITIAL,
      VideoModeStore.VIEW_MORE,
      VideoModeStore.VIEW_ALL])

  _setHistoryVideosPerPage: ({ val, ignore } = { val: null, ignore: false }) ->
    return if ignore == true || @_fromBackOrForwardButton == true
    @_currentQuery = document.location.href
    historyState = history.state || {}
    historyState.videos_per_page = val || @.getFromStorage(VideoModeStore.STORAGE_PER_PAGE_KEY)
    unless historyState.videos_per_page?
      historyState.videos_per_page = LpBoclips.VideoModeStore.VIEW_INITIAL
    history.replaceState(historyState, '')

  goBackOrForward: ({videos_per_page}) ->
    return unless @_validPerPageKey(videos_per_page)
    return if videos_per_page == VideoModeStore.VIEW_INITIAL && @.canViewInitial() && @.visitCurrentPath()
    return if String(videos_per_page) == String(@.getFromStorage(VideoModeStore.STORAGE_PER_PAGE_KEY)) && @.visitCurrentPath()
    @_fromBackOrForwardButton = true
    if videos_per_page == VideoModeStore.VIEW_INITIAL && (@.canViewMore() || @.canViewAll())
      @resetView(emit: false)
    else if videos_per_page == VideoModeStore.VIEW_ALL && !@.canViewAll()
      @.toggleViewAll(emit: false)
    @_loading = true
    @_triggerSearch = false
    @_historyNavigationTriggerSearch = true
    @.emitChange()

LpBoclips.VideoModeStore = VideoModeStore
